/**
 * ThemeToggle - Minimal premium Sun/Moon toggle for topbar.
 * Toggles between light and dark; if user was on system, sets explicit light/dark.
 */

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/providers/theme-provider';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ThemeToggle({ className }: { className?: string }) {
  const { resolvedTheme, toggle } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      className={cn(
        'h-9 w-9 rounded-lg border border-white/10 bg-white/[0.04] hover:bg-white/[0.08] hover:border-white/14 text-muted-foreground hover:text-foreground transition-colors',
        'dark:border-white/10 dark:bg-white/[0.04] dark:hover:bg-white/[0.08]',
        className
      )}
    >
      {resolvedTheme === 'dark' ? (
        <Sun className="h-4 w-4" strokeWidth={1.5} />
      ) : (
        <Moon className="h-4 w-4" strokeWidth={1.5} />
      )}
    </Button>
  );
}
